import { Box, Typography } from "@mui/material";
import { ImWarning } from "react-icons/im";

export default function NMSRateOptions({ unConsentedRate, consentedRate }) {
    return (
        <div className="nms-options-rate">
            <Box className={`nms-option-price`}>
                <Typography
                    id="modal-title"
                    variant="h6"
                    sx={{ fontSize: "14px", margin: "15px" }}
                >
                    {" "}
                    Unconsented{" "}
                </Typography>
                <div className="nms-option-rate">
                    <div className="nms-option-orbit-wrapper">
                        <Typography
                            id="modal-title"
                            variant="h6"
                            sx={{ fontSize: "14px" }}
                        >
                            {" "}
                            £ {unConsentedRate}{" "}
                        </Typography>
                    </div>
                </div>
                <div className="nms-rate-decription-orbit-wrapper">
                    <ImWarning size={40} color={"red"} />
                    <p className="nms-price-warning">
                        {" "}
                        Unconsented NMS is where you have not engaged with the patient in
                        order to gain the consent{" "}
                    </p>
                </div>
            </Box>
            <Box className={`nms-option-price`}>
                <Typography
                    id="modal-title"
                    variant="h6"
                    sx={{ fontSize: "14px", margin: "15px" }}
                >
                    {" "}
                    Consented{" "}
                </Typography>
                <div className="nms-option-rate">
                    <div className="nms-option-orbit-wrapper">
                        <Typography
                            id="modal-title"
                            variant="h6"
                            sx={{ fontSize: "14px" }}
                        >
                            £ {consentedRate}{" "}
                        </Typography>
                    </div>
                </div>
                <div className="nms-rate-decription-orbit-wrapper">
                    <ImWarning size={30} color={"red"} />
                    <p className="nms-price-warning">
                        {" "}
                        Consented NMS is where you have gained full consent from the
                        patient{" "}
                    </p>
                </div>
            </Box>
        </div>
    )
}
